/** @type {import('./$types').PageLoad} */
export async function load({ params }) {
	const apiURL = import.meta.env.VITE_APIURL;
	const documentId = params.documentId;
	const apiEndpoint = apiURL + 'programs/programs/' + documentId;

	const documentObject = await (await fetch(apiEndpoint)).json();

	return {
		documentObject: documentObject
	};
}
